import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import ModalComponent from '../components/ModalComponent';
import {enToFa} from '../utils/NumberUtility';
import Logout from '../assets/images/logout.svg';
import Profile from '../assets/images/profile.png';
import Lock from '../assets/images/lock.png';
import Elevator from '../assets/images/elevator.png';
import Coin from '../assets/images/coin.png';
import {startBuyElevator} from '../actions/auth';
import Loading from '../components/Loading';
import Pagination from '../components/Pagination';
import VehicleAdItem from '../components/VehicleAdItem';
import JobAdItem from '../components/JobAdItem';
import AgencyAdItem from '../components/AgencyAdItem';
import GalleryAdItem from '../components/GalleryAdItem';
import PriceAdItem from '../components/PriceAdItem';
import {nextPage, prevPage, dashboardReset, startGetAllMyAds, startGetAllMyStores, startGetAllMyAlarms, startGetAllMyFavourites, startGetLatestPrices} from '../actions/dashboard';
import {startChangePass, logoutUser} from '../actions/auth';
import AlarmAdItem from '../components/AlarmAdItem';

const Dashboard = (props) => {

    const sections = [{
        page: "ads",
        identifier: "آگهی"
    }, {
        page: "auction",
        identifier: "نمایندگی و نمایشگاه"
    }, {
        page: "alarm",
        identifier: "گوش به زنگ"
    }, {
        page: "price",
        identifier: "قیمت روز"
    }, {
        page: "mark",
        identifier: "نشان ها"
    }]
    
    const elevators = [{
        count: 1,
        label: "خرید ۱ آسانسور"
    }, {
        count: 2,
        label: "خرید ۲ آسانسور"
    }, {
        count: 3,
        label: "خرید ۳ آسانسور"
    }, {
        count: 5,
        label: "خرید ۵ آسانسور"
    }, {
        count: 10,
        label: "خرید ۱۰ آسانسور"
    }, {
        count: 20,
        label: "خرید ۲۰ آسانسور"
    }]

    const [page, setPage] = useState(sections[0].page)
    const [infoModal, setInfoModal] = useState(false);
    
    const [elevatorModal, setElevatorModal] = useState(false);
    const [elevatorError, setElevatorError] = useState(false);
    const [elevatorCount, setElevatorCount] = useState(-1);

    const [loading, setLoading] = useState(true);

    const [passModal, setPassModal] = useState(false);
    const [pass, setPass] = useState("");
    const [passError, setPassError] = useState(false);
    const [passRepeat, setPassRepeat] = useState("");
    const [passRepeatError, setPassRepeatError] = useState(false);

    useEffect(() => {
        if (loading){
            initializeDataFetch(page);
        }
    }, [loading])

    const onSectionSelect = (e) => {
        if (e.target.id !== page){
            setLoading(true)
            setPage(e.target.id)
            props.dashboardReset()
            initializeDataFetch(e.target.id)
        }
    }

    const initializeDataFetch = (currentSection) => {
        switch (currentSection) {
            case "ads":
                props.startGetAllMyAds()
                    .then(({success, error}) => {
                    if (success){
                        setLoading(false)
                    }
                    else{
                        setLoading(false)
                    }
                })
                break;
            case "alarm":
                props.startGetAllMyAlarms()
                    .then(({success, error}) => {
                    if (success){
                        setLoading(false)
                    }
                    else{
                        setLoading(false)
                    }
                })
                break;
            case "auction":
                props.startGetAllMyStores()
                    .then(({success, error}) => {
                    if (success){
                        setLoading(false)
                    }
                    else{
                        setLoading(false)
                    }
                })
                break;
            case "price":
                props.startGetLatestPrices()
                    .then(({success, error}) => {
                    if (success){
                        setLoading(false)
                    }
                    else{
                        setLoading(false)
                    }
                })
                break;
            case "mark":
                props.startGetAllMyFavourites()
                    .then(({success, error}) => {
                    if (success){
                        setLoading(false)
                    }
                    else{
                        setLoading(false)
                    }
                })
                break;
        }
    }

    const onAddNew = (e) => {
        switch(e.target.id) {
            case 'add_ad':
                props.history.push('/register-vehicle');
                break;
            case 'add_job':
                props.history.push('/register-job');
                break;
            case 'add_agency':
                props.history.push('/register-agency');
                break;
            case 'add_gallery':
                props.history.push('/register-gallery');
                break;
            case 'add_alarm':
                props.history.push('/register-alarm');
                break;
        }
    }

    const onExitClicked = (e) => {
        localStorage.removeItem("authToken");
        props.logoutUser()
        props.history.push('/');
    }

    const onChangePasswordClicked = (e) => {
        setPassModal(true);
    }

    const onChangeInfoClicked = (e) => {
        setInfoModal(true);
    }

    const handleCloseInfoModal = (e) => {
        setInfoModal(false);
    }

    const onChangeElevatorClicked = (e) => {
        setElevatorModal(true);
    }

    const handleCloseElevatorModal = (e) => {
        setElevatorModal(false);
        setElevatorCount(-1);
        setElevatorError(false);
    }

    const handleClosePasswordModal = (e) => {
        setPassModal(false);
        setPass("");
        setPassRepeat("");
        setPassError(false);
        setPassRepeatError(false);
    }

    const handleSubmitElevatorModal = (e) => {
        if (elevatorCount > 0) {
            props.buyMoreElevators(elevatorCount)
            .then(({success, error}) => {
            if (success){
                handleCloseElevatorModal()
            }
        })
        }
        else {
            setElevatorError(true)
        }
    }

    const handleSubmitPasswordModal = (e) => {
        let hasError = false;
        if (pass === ""){
            setPassError(true)
            hasError = true;
        }
        else {
            setPassError(false)
        }
        if (passRepeat === ""){
            setPassRepeatError(true)
            hasError = true;
        }
        else {
            setPassRepeatError(false)
        }
        if (pass !== "" && passRepeat !== "" && pass !== passRepeat){
            hasError = true;
            setPassError(true)
            setPassRepeatError(true)
        }
        if (!hasError){
            props.startChangePass({newPass:pass, newPassRetype: passRepeat})
            .then(({success, error}) => {
            if (success){
                handleClosePasswordModal()
            }
        })
        }
    }

    const onElevatorChanged = (e) => {
        console.log(e.target.value, typeof e.target.value)
        if (e.target.value > 0) {
            setElevatorCount(Number(e.target.value))
            setElevatorError(false)
        }
    }

    const onCurrentSection = () => {
        switch(page) {
            case "ads":
                return "آگهی ها";
            case "alarm":
                return "گوش به زنگ";
            case "auction":
                return "نمایندگی و نمایشگاه";
            case "price":
                return "قیمت روز";
            case "mark":
                return "نشان های من";
        }
    }

    const handleNext = () => {
        props.nextPage();
        setLoading(true);
    }

    const handlePrev = () => {
        props.prevPage();
        setLoading(true);
    }

    const listRenderer = () => {
        switch (page) {
            case 'ads':
                return props.ads.map((el) => el.identifier === 'job' ? 
                (<JobAdItem key={el.id} info={el} push={props.history.push} classes="dash" sharedElement={true} dashboardType={page}/>) :
                (<VehicleAdItem key={el.id} info={el} push={props.history.push} classes="dash" sharedElement={true} dashboardType={page}/>))
            case 'auction':
                return props.ads.map((el) => el.identifier === 'agency' ?
                (<AgencyAdItem key={el.id} info={el} classes="dash" push={props.history.push} dashboardType={page}/>) :
                (<GalleryAdItem key={el.id} info={el} classes="dash" push={props.history.push} dashboardType={page}/>))
            case 'alarm':
                return props.ads.map((el) => (<AlarmAdItem key={el.id} info={el} classes="dash" push={props.history.push} dashboardType={page}/>))
            case 'price':
                return props.ads.map((el) => (<PriceAdItem key={el.id} info={el} push={props.history.push}/>))
            case 'mark':
                return props.ads.map((el) => el.identifier === 'job' ? 
                (<JobAdItem key={el.id} info={el} push={props.history.push} classes="dash" sharedElement={true}/>) :
                (<VehicleAdItem key={el.id} info={el} push={props.history.push} classes="dash" sharedElement={true}/>))
        }
    }

    const onPassChanged = (e) => {
        setPass(e.target.value)
    }

    const onPassRepeatChanged = (e) => {
        setPassRepeat(e.target.value)
    }

    return (
        <div className="vehicle-details__main-scroll h-100 px-0">
            <div className="dashboard__section">
                {
                    sections.map((el) => (
                        <button className={page === el.page ? 'dashboard__section-btn--active' : 'dashboard__section-btn'} id={el.page} onClick={onSectionSelect}>{el.identifier}</button>
                    ))
                }
            </div>
            <div className="vehicle-details__sub-bg mt-3 pb-4 shrink-patch">
                <div className="dashboard__main-container">
                <div className="optimized__d-flex-class flex-wrap">
                    <div className="col-2 nopadding mt-4">
                        <img className="dashboard__profile-image" src={Profile}/>
                    </div>
                    <div className="col-10 nopadding">
                        <span onClick={onExitClicked} class="dashboard__exit-btn">
                            <img className="dashboard__logout-image" src={Logout}/>
                            <a class="py-1 mt-2 mt-md-0 px-2">خروج</a>
                        </span>
                        <span className="dashboard__welcome">سلام، به پروفایل‌تان خوش آمدید</span>
                        <div className="dashboard__action-arrow">
                            <img className="dashboard__arrow-image" src={Lock}/>
                            {/* <span className="dashboard__spacer"/> */}
                            <div className="dashboard__action-bg">
                                <span className="dashboard__action-title gray" onClick={onChangePasswordClicked}>تغییر رمز</span>
                                <div className="arrow-div gray"/>
                                <span className="dashboard__action-info">{`شماره موبایل: ${enToFa(props.info.phoneNo)}`}</span>
                            </div>
                            <div className="arrow-div blue"/>
                            <ModalComponent
                                    onRequestClose={handleClosePasswordModal}
                                    isOpen={passModal}>
                                    <div className="dashboard__info-modal d-flex flex-column flex-grow-1">
                                        <span className="dashboard__modal-head">تغییر کلمه عبور:</span>
                                        <input className={passError ? "register__dropdown--error" : "register__dropdown"} value={pass} onChange={onPassChanged} type="password" placeholder="رمز جدید"></input>
                                        <input className={passRepeatError ? "register__dropdown--error" : "register__dropdown"} value={passRepeat} onChange={onPassRepeatChanged} type="password" placeholder="تکرار رمز جدید"></input>
                                        <div className="optimized__d-flex-class justify-content-end pt-3">
                                            <button className="btn__close--secondary mx-2" onClick={handleClosePasswordModal}>انصراف</button>
                                            <button className="btn__close mx-0" onClick={handleSubmitPasswordModal}>ثبت</button>
                                        </div>
                                    </div>
                                </ModalComponent>
                        </div>
                        <div className="optimized__d-flex-class align-items-end mt-4">
                            <span className="dashboard__elevator-title" onClick={onChangeInfoClicked}>آسانسور چیست؟</span>
                            <ModalComponent
                                onRequestClose={handleCloseInfoModal}
                                isOpen={infoModal}>
                                <div className="dashboard__info-modal d-flex flex-column flex-grow-1">
                                    <span>با استفاده از «آسانسور» آگهی خود را بلافاصله در صدر لیست آگهی‌ها نمایش دهید و آگهی خود را به فروش نزدیک‌تر کنید.</span>
                                    <div className="optimized__d-flex-class justify-content-end pt-3">
                                        <button className="btn__close m-0" onClick={handleCloseInfoModal}>بستن</button>
                                    </div>
                                </div>
                            </ModalComponent>
                            <div className="dashboard__elevator">
                                <img className="dashboard__elevator-image" src={Elevator}/>
                                <div className="dashboard__coin-box" onClick={onChangeElevatorClicked}>
                                    <span className="dashboard__coin-title">خرید آسانسور</span>
                                    <img className="dashboard__coin-image" src={Coin}/>
                                </div>
                                <ModalComponent
                                    onRequestClose={handleCloseElevatorModal}
                                    isOpen={elevatorModal}>
                                    <div className="dashboard__info-modal d-flex flex-column flex-grow-1">
                                        <span> پس از خرید میتوانید با استفاده از دکمه «آسانسور» بر روی آگهی، آن را اعمال کنید. </span>
                                        <select className={`mt-4 ${elevatorError ? "register__dropdown--error" : "register__dropdown"}`} onChange={onElevatorChanged} value={elevatorCount}>
                                            <option value="-1">تعداد آسانسور را انتخاب کنید</option>
                                            {elevators.map((el) => {
                                                return (<option key={el.count} value={el.count}>{el.label}</option>)
                                            })}
                                        </select>
                                        <div className="optimized__d-flex-class justify-content-end pt-3">
                                            <button className="btn__close--secondary mx-2" onClick={handleCloseElevatorModal}>انصراف</button>
                                            <button className="btn__close mx-0" onClick={handleSubmitElevatorModal}>خرید</button>
                                        </div>
                                    </div>
                                </ModalComponent>
                                <div className="dashboard__elevator-count-box">
                                    <span className="dashboard__elevator-count-title">آسانسور</span>
                                    <span className="dashboard__elevator-count">{enToFa(props.info.elevators)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dashboard__actions-container">
                    <button className="dashboard__action-btn" id="add_ad" onClick={onAddNew}>ثبت آگهی</button>
                    <button className="dashboard__action-btn" id="add_job" onClick={onAddNew}>ثبت مشاغل</button>
                    <button className="dashboard__action-btn" id="add_gallery" onClick={onAddNew}>ثبت نمایشگاه</button>
                    <button className="dashboard__action-btn" id="add_agency" onClick={onAddNew}>ثبت نمایندگی</button>
                    <button className="dashboard__action-btn" id="add_alarm" onClick={onAddNew}>ثبت گوش به زنگ</button>
                </div>
                <span className="dashboard__current-title">{onCurrentSection()}</span>
                {
                    loading ? (
                        <Loading/>
                    ) : (
                        <>
                            {
                                props.total > 0 ? (
                                    <>
                                        {listRenderer()}
                                    </>
                                ) : (
                                    <span className="dashboard__not-fount">موردی یافت نشد</span>
                                )
                            }
                            <Pagination
                                currentPage={props.page}
                                pageCount={props.pageCount}
                                handleNext={handleNext}
                                handlePrev={handlePrev}
                            />
                        </>
                    )
                }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state, props) => ({
    info: state.auth.info,
    page: state.dashboard.page,
    pageCount: Math.ceil(state.dashboard.total / state.dashboard.page_size),
    ads: state.dashboard.items,
    total: state.dashboard.total
});

const mapDispatchToProps = (dispatch) => ({
    buyMoreElevators: (amount) => dispatch(startBuyElevator(amount)),
    nextPage: () => dispatch(nextPage()),
    prevPage: () => dispatch(prevPage()),
    dashboardReset: () => dispatch(dashboardReset()),
    startGetAllMyAds: () => dispatch(startGetAllMyAds()),
    startGetAllMyStores: () => dispatch(startGetAllMyStores()),
    startGetAllMyAlarms: () => dispatch(startGetAllMyAlarms()),
    startGetAllMyFavourites: () => dispatch(startGetAllMyFavourites()),
    startGetLatestPrices: () => dispatch(startGetLatestPrices()),
    startChangePass: (body) => dispatch(startChangePass(body)),
    logoutUser: () => dispatch(logoutUser())
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);